
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
	Multimedia Coordinator 
</h2>


  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">


        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
            <div class="feature-box style-2 left">
              <i class="fa fa-graduation-cap"></i>
              <div class="text para_cls">
                <h3>Qualification & Experience : </h3>
                <p> <span class="step_no">1</span> B.sc or M.sc degree in Broadcasting, Journalism, Mass Communications, Multimedia Production, Visual Communication, Electronic Media, OR a related discipline in any prestigious institution.</p>
				<p> <span class="step_no">2</span> 3-5 Years of Experience </p>
               <!-- <p> <span class="step_no">2</span>Two (2) years of experience with multimedia/audio-video/production and post-production using a professional news non-linear video editing system such as Final Cut Pro, Avid or Premiere Pro.</p>
                
                
               <p> <span class="step_no">3</span>Demonstrated effective oral and written communication skills and ability to Determine organizational and analytical skills. 
               </p>
               <p> <span class="step_no">4</span>Capacity to work both independently and as a member of a team.</p> -->
               <!--<p> <span class="step_no">5</span>Experience of working towards creation of/leading incubation centres. start-ups would be preferred  </p>
				<p> <span class="step_no">6</span>Experience in Policy facilitation, project management will be preferred. </p>
				<p> <span class="step_no">7</span>Special skill required (if applicable): Excellent with MS Office, Excel, Power Point</p>
				<p> <span class="step_no">8</span>Details of Competencies required for the position: Competency to perform advisory role, stakeholder management and policy analysis to support entrepreneurial division for MSDE</p>
				<p> <span class="step_no">9</span>Key Performance Indicators (KPIs):</p>
				<p>	•	Capacity to function as part of a multi disciplinary team.</p>
				<p>	•	Formulation of Project Proposals as per MSDE mandate</p>
				<p>	•	Pro-actively interact with key stake-holders, Ministries, State Governments, UN agencies, Corporate Sector etc. </p>-->
				

              </div>
            </div>
          </div>
          <!-- feature box close -->
  
       
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>PREFERRED:</h3>
        <p> <span class="step_no">1</span>Four (4) years of progressively experience as a coordinator in e-learning industry Broadcasting, Journalism, Mass Communications, or related field. </p>
        <p> <span class="step_no">2</span> conceptualization, design, production of multimedia materials for varied platforms such as Print, Audio/Video and Web.</p>
        <p> <span class="step_no">3</span>Experience using a non-linear audio and video editing, Motion Graphic Videos, 3D and 2D animation and Video Production.</p>
        <p> <span class="step_no">4</span>Conversing in Hindi language is an added advantage </p>
		
        <!--p> <span class="step_no">3</span>In-depth knowledge of Database Technologies, Architecture and Data security.</p>
		<p> <span class="step_no">4</span>Experience in Designing Logical / Physical Data Models and create Physical Databases for the Software Development Projects</p>
		<p> <span class="step_no">5</span>Experience in developing Functions and Triggers</p>
		<p> <span class="step_no">6</span>Experience in Management Information Systems (MIS)</p>-->
		
       </div>
    </div>
  </div>
  
  
  <!-- feature box close -->



  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>JOB PROFILE:</h3>
        <p> <span class="step_no">1</span>Understand the requirements and create or edit the paperwork’s as required.</p>
        <p> <span class="step_no">2</span>Formulate and plan a realistic timeline to the team and maintain monthly work reports</p>
        <p> <span class="step_no">3</span>Assist in working with vendors and SME’s, providing work orders, approvals, monitoring reports and follow-up with the firm as per the timeline.</p>
        <p> <span class="step_no">4</span>Visually enhances presentation materials created by others using sound, multimedia graphics, and video elements.</p>
        <p> <span class="step_no">5</span>Conducts research and collaborates with team members to create informational graphics</p>
        <p> <span class="step_no">6</span>Selects stock video footage and still photography for use in multimedia projects</p>
        <p> <span class="step_no">7</span>Assists in the maintenance of a multimedia archive</p>
		<p> <span class="step_no">8</span>Works with different staff members to determine and ensure effective implementation of multimedia deliverables</p>
        <p> <span class="step_no">9</span>Writes and edits scripts, storyboards and specialty files for use in various types of multimedia and video projects and presentations</p>
		<p> <span class="step_no">10</span>Manage and promote Social media platforms and act as a staff photographer as needed. </p>
        <!--<p> <span class="step_no">5</span> Experience in working with agile methodologies. </p>-->
       </div>
    </div>
  </div>
  <!-- feature box close -->



  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p> <span class="step_no">1</span> Rs. 40,000/-  to 50,000/- Per month   </p>
		<!--<p> <span class="step_no">2</span> Rs. 1,00,000/- per month (consolidated pay) for 3+ Experience from which standard TDS will be deducted at source. Not entitled to any other allowance or benefits.  </p>-->


      </div>
    </div>
  </div>
  <!-- feature box close -->

   <!-- feature box begin -->
   <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Other terms and conditions:</h3>
        <p> <span class="step_no">1</span>All candidates should mail their resume and their showreels to nimirecruitment@gmail.com on or before 26th September 2022. </p>
        <p> <span class="step_no">2</span>The Candidate has to mention for which job profile He/She is applying at the top of the resume they are submitting. If not, the resume will automatically get rejected. </p>
        <p> <span class="step_no">3</span>The appointments to the above posts are purely contractual and will terminate automatically on the expiry of the contract period. </p>
        <p> <span class="step_no">4</span>The place of posting will be at Chennai only. On occasions, the job may involve touring also.</p>
        <p> <span class="step_no">5</span>Candidates selected for recruitment shall be prepared to join on short notice. </p>
		<p> <span class="step_no">6</span>Candidate must bring their show reel (works) at the time of interview</p>
        <p> <span class="step_no">7</span>Candidate attending the skill test & interview would not be paid TA/DA by NIMI</p>
        <p> <span class="step_no">8</span>Candidate who fulfils the required eligibility conditions shall bring their original certificate and other documents on the date and time mentioned above in support of their claim in age, educational qualifications, experience etc.</p>
        <!--<p> <span class="step_no">9</span> Planning and coordination of innovation events, trainings, national awards, workshops, conferences, visits, and exchange programme etc.</p>-->
        
      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!--<div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Age</h3>
        <p><span class="step_no">1</span>Chennai</p>-->
		<!--<p>Up to 35 years</p>
	
      </div>
    </div>
  </div>-->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 08th August 2023 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->

  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Period of Contract </h3>
        <!--<p><span class="step_no">1</span>Chennai</p>-->
		<p>The appointment to the post will be purely on contract basis initially for a period of one year, further extendable subject to satisfactory performance and requirement of services for another year. The performance of the consultant will be reviewed every year and the contract shall be extended or discontinued (as the case may be) depending on the performance. The decision of NIMI shall be final in this regard.</p>
	
      </div>
    </div>
  </div>

    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
        <p><span class="step_no">1</span>04- Post   chennai </p>
		<!--<p><span class="step_no">1</span>04 (Four)at NIMI, Chennai</p>-->
	
      </div>
    </div>
  </div>
  <!-- feature box close -->
  
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Selection Process:</h3>
        <p><span class="step_no">1</span>Short listed candidates will be called for Computer test followed by Interview. </p>
        <!--<p><span class="step_no">1</span>Selection will be done on the basis of performance in the personal interview by a selection committee.</p>
		<p><span class="step_no">2</span>Only shortlisted candidates will be called for the interview.</p>
		<p><span class="step_no">3</span>No TA/DA will be paid for attending the interview.</p>
        <p><span class="step_no">4</span>At the time of the interview, the candidates shall produce their original certificates for verification. </p>-->

      </div>
    </div>
  </div>
  <!-- feature box close -->
  
     <!-- feature box begin -->
  <!--<div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Attendance and leave policy:</h3>
        <p><span class="step_no">1</span>The working hours will be the same as for NIMI.</p>
		<p><span class="step_no">2</span>No extra remuneration shall be paid for working beyond office hours or on Saturdays/Sundays/gazetted holidays.</p>
		<p><span class="step_no">3</span>Compulsory leave in such cases shall be at the discretion of the competent authority. </p>


      </div>
    </div>
  </div>-->
  <!-- feature box close -->
  
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Confidentiality and secrecy :</h3>
        <p><span class="step_no">1</span>The consultant maintain confidentiality and will not divulge any information gathered during the period of engagement with the NIMI to any person who is not authorised to know the same. </p>
		


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
   <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Documents for attending the Test and Interview :</h3>
        <p><span class="step_no">1</span>2 copies of passport size photographs</p>
		<p><span class="step_no">2</span>Original and self attested copies of educational certificates</p>
		<p><span class="step_no">3</span>Original and self attested copies of  Caste certificate  and Aadhar card</p>
		<p><span class="step_no">4</span>Original  and self attested copies of Experience certificates</p>
		


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
  
<!--
  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div> -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>









